import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    if (value) {
      if (value.length > 2) {
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      } else {
        return value;
      }
    } else {
      return value;
    }
  }
}
